import { render, staticRenderFns } from "./CouponExpiration.vue?vue&type=template&id=0b92df4d&"
import script from "./CouponExpiration.vue?vue&type=script&lang=js&"
export * from "./CouponExpiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b92df4d')) {
      api.createRecord('0b92df4d', component.options)
    } else {
      api.reload('0b92df4d', component.options)
    }
    module.hot.accept("./CouponExpiration.vue?vue&type=template&id=0b92df4d&", function () {
      api.rerender('0b92df4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ecoupon/campaign/components/CouponExpiration.vue"
export default component.exports